import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import SignaturePad from 'react-signature-canvas';
import { PenLineIcon } from 'lucide-react';

// value shape: { signed: boolean, image: string|undefined } — combines the legacy
// signIsLegal (1|2) + signatureImg fields into one answer the generic form state can hold.
//
// Note: the reference design's "signature" field is a plain typed-cursive-font text input.
// This app's existing backend contract requires an actual drawn signature image
// (signatureImg, a base64 PNG), so this keeps the functional signature pad rather than
// downgrading to typed text — restyled to match the surrounding visual language instead.
const SignatureField = ({ value, onChange }) => {
    const [signPadPopup, setSignPadPopup] = useState(false);
    const [isSignatureClear, setIsSignatureClear] = useState(true);
    const signaturePadRef = useRef();

    const handleSignaturePadChange = e => {
        if (e.isTrusted) setIsSignatureClear(false);
    };

    const handleSignaturePadSave = () => {
        if (!isSignatureClear) {
            onChange({ signed: true, image: signaturePadRef.current.getTrimmedCanvas().toDataURL('image/png') });
            setSignPadPopup(false);
        }
    };

    return (
        <div className="tw-rounded-xl tw-border tw-border-sand-300 tw-bg-white tw-p-4">
            {value?.signed && value?.image ? (
                <div>
                    <img src={value.image} alt="Signature" className="tw-h-16 tw-border-b tw-border-sand-300" />
                    <div className="tw-mt-3 tw-flex tw-gap-2">
                        <button
                            type="button"
                            onClick={() => setSignPadPopup(true)}
                            className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-sand-300 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-600 tw-transition hover:tw-bg-sand-100">
                            <PenLineIcon className="tw-h-4 tw-w-4" aria-hidden="true" />
                            Re-sign
                        </button>
                        <button
                            type="button"
                            onClick={() => onChange({ signed: false, image: undefined })}
                            className="tw-text-xs tw-font-semibold tw-text-brand-600 hover:tw-text-brand-800">
                            Remove
                        </button>
                    </div>
                </div>
            ) : (
                <button
                    type="button"
                    onClick={() => setSignPadPopup(true)}
                    className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-brand-600 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-brand-700 tw-transition hover:tw-bg-brand-50">
                    <PenLineIcon className="tw-h-4 tw-w-4" aria-hidden="true" />
                    Add signature
                </button>
            )}

            <Modal dialogClassName="h_auto" show={signPadPopup} animation={false} centered>
                <Modal.Body>
                    <div className="p-5">
                        <h3 className="text-center mb-4">Signature</h3>
                        <div className="signature_pad">
                            <SignaturePad onEnd={handleSignaturePadChange} ref={signaturePadRef} canvasProps={{ width: 361, height: 200, className: 'sigCanvas' }} />
                        </div>
                        <div className="mt-2 d-flex justify-content-center">
                            <button disabled={isSignatureClear} className="btn btn-primary w-100" onClick={handleSignaturePadSave}>Done</button>
                            <button className="btn btn-primary w-100 ms-1" onClick={() => { signaturePadRef.current.clear(); setIsSignatureClear(true); }}>Clear</button>
                            <button className="btn btn-light w-100 ms-1" onClick={() => setSignPadPopup(false)}>Cancel</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SignatureField;
